<template>
  <section ref="section" id="programm">
    <h1 class="no-pad" v-html="programm.title"></h1>
    <div ref="fragen" class="aha-row pre-programme">
      <p v-html="programm.friday_text"></p>
      <div ref="fragens" class="ahafrage">
      </div>
    </div>
    <div ref="fragen" class="aha-row pre-programme">
      <p v-html="programm.saturday_text"></p>
      <div ref="fragens" class="ahafrage">
      </div>
    </div>
    <!-- <template v-if="this.$route.name === 'preview'"> -->
    <template>
      <h1 class="pad-day" v-if="this.$route.name !== 'english'">Freitag</h1>
      <h1 class="pad-day" v-else>Friday</h1>
      <fragen :post="fri" v-for="fri in friday" :key="fri.uid"></fragen>
      <h1 class="pad-day" v-if="this.$route.name !== 'english'">Samstag</h1>
      <h1 class="pad-day" v-else>Saturday</h1>
      <fragen :post="sat" v-for="sat in saturday" :key="sat.uid"></fragen>
    </template>
  </section>
</template>

<script>
import Fragen from '../components/Fragen.vue'

export default {
  name: 'programm',
  components: {
    Fragen
  },
  computed: {
    programm () {
      return this.$store.getters.getPageByUID('programm')
    },
    subpages () {
      return this.$store.getters.getPagesByType('frage')
    },
    friday () {
      let array = []
      for (var i = 0; i < this.subpages.length; i++) {
        var day = this.subpages[i].time
        var dayName = day.slice(8, 10)
        if (dayName === '25') {
          array.push(this.subpages[i])
        }
      }
      return array
    },
    saturday () {
      let array = []
      for (var i = 0; i < this.subpages.length; i++) {
        var day = this.subpages[i].time
        var dayName = day.slice(8, 10)
        if (dayName === '26') {
          array.push(this.subpages[i])
        }
      }
      return array
    },
    images () {
      return this.$store.getters.getPageByUID('home')
    }
  },
  data () {
    return {
    }
  },
  created () {
    window.addEventListener('scroll', this.inViewport)
  },
  destroyed () {
    window.removeEventListener('scroll', this.inViewport)
  },
  methods: {
    inViewport () {
      let hW = window.innerHeight / 2
      let center = window.scrollY + hW
      let top = this.$refs.section.offsetTop - 4
      let height = top + this.$refs.section.clientHeight + 4
      if (center > top && center < height) {
        this.$refs.fragen.classList.add('active')
      } else {
        this.$refs.fragen.classList.remove('active')
      }
    }
  },
  mounted () {
    this.$forceUpdate()
  }
}
</script>

<style lang="scss">
@import '../assets/styles/base';
  .pad-day {
    padding-top: $gap * 4;
    margin-bottom:0;
  }
  .aha-row {
    padding:$gap / 2 0;
    border-bottom:2px solid $font-color;
    @media only screen and (max-width: $phone) {
      border-bottom:1px solid $font-color;
    }
    &.clickable {
      // cursor:pointer;
    }
    &.active {
      .ahafrage, .aha-logo {
        display:block;
      }
    }
    p {
      margin-bottom:0;
    }
    .ahafrage {
      position:fixed;
      top:0;
      left:0;
      width:50%;
      height:100vh;
      background-image: url('../assets/images/00_Fragezeichen.svg');
      background-repeat: no-repeat;
      background-position: center center;
      z-index:6;
      padding:$gap / 2;
      display:none;
    }
  }
</style>
